// BEAM brand mark (Aperture) + wordmark.
// The runtime mark is drawn with react-native-svg (no .svg import needed).
// Tiles are for the APP ICON ONLY — never render the in-app mark on a filled tile.
import React from 'react';
import { View, Text, StyleSheet, type StyleProp, type ViewStyle } from 'react-native';
import Svg, { Line, Circle } from 'react-native-svg';
import { palette, fontFamily } from '../../theme';

type Tone = 'ink' | 'light'; // ink → on light surfaces; light → on dark surfaces

/** The Aperture mark on its own (nav brand, splash, list-section icon). */
export function BeamMark({ size = 28, tone = 'ink' }: { size?: number; tone?: Tone }) {
  const base = tone === 'light' ? palette.paper : palette.ink;
  // Copper exit visually merges below ~18px — fall back to single color there.
  const exit = size < 18 ? base : palette.copper;
  return (
    <Svg width={size} height={size} viewBox="0 0 40 40" fill="none">
      <Line x1={6} y1={20} x2={20} y2={20} stroke={base} strokeWidth={2.6} strokeLinecap="round" />
      <Line x1={20} y1={20} x2={34} y2={20} stroke={exit} strokeWidth={2.6} strokeLinecap="round" />
      <Circle cx={20} cy={20} r={7} fill="none" stroke={base} strokeWidth={2.4} />
    </Svg>
  );
}

/** Mark + lowercase wordmark lockup. Default brand presentation in-app. */
export function BeamLogo({
  size = 28,
  tone = 'ink',
  style,
}: {
  size?: number;
  tone?: Tone;
  style?: StyleProp<ViewStyle>;
}) {
  const wordColor = tone === 'light' ? palette.paper : palette.ink;
  return (
    <View style={[styles.row, style]}>
      <BeamMark size={size} tone={tone} />
      <Text style={[styles.wordmark, { fontSize: size * 0.92, color: wordColor }]}>beam</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  wordmark: { fontFamily: fontFamily.display, letterSpacing: 0.3, includeFontPadding: false },
});
